export default __webpack_public_path__ + "static/media/01.23c66c2a.png";